import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL

export const getCountries = (accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'location_select',
            'action': 'COUNTRY',
            'variables': '{}'
        })
    })
}

export const getStatesAndCities = (accessToken, action, variables) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'location_select',
            'action': action,
            'variables': JSON.stringify(variables)
        })
    })
}

export const getCompany = (accessToken, identification) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'company_select',
            'action': 'SELECT_BY_IDENTIFICATION',
            'variables': JSON.stringify({ 'identification': identification })
        })
    })
}

export const getOffice = (accessToken, idt) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'company_select',
            'action': 'SELECT_OFFICE_BY_IDSUPPLIER',
            'variables': JSON.stringify({ 'identification': idt })
        })
    })
}